import React from 'react';
import { observer } from 'src/utils/mobx-react';
import InlineScroll from 'src/components/InlineScroll/InlineScroll.jsx';
import { SportCollection, TwoParticipantsSportsTabState } from './TwoParticipantsSportsTabState';
import { FilterTabs } from 'src/components/Filters/FilterTabs';

interface PropsType {
    sportState: TwoParticipantsSportsTabState;
    collectionState: SportCollection;
}

export const MenuScrollCompetition = observer('MenuScrollCometition', (props: PropsType) => {
    const { sportState, collectionState } = props;

    return (
        <div className='two-participants-events-filter'>
            <InlineScroll>
                <FilterTabs
                    available={collectionState.competitions}
                    active={sportState.currentCompetition}
                    onChange={sportState.changeCompetition}
                />
            </InlineScroll>
        </div>
    );
});
